export default __webpack_public_path__ + "locales/uk-UA/SharingPanel.json?hash=deaa0de9fb86965fff18387cd5fe7cee";